import { type TopIndependentStatus } from '#app/__generated__/api.js';

export enum ActionTypes {
  HANDLE_EXCLUDE_FROM_DISCOVER_CHANGE = 'handleExcludeFromDiscoverChange',
  HANDLE_EXCLUDE_FROM_MATCHING_CHANGE = 'handleExcludeFromMatchingChange',
  HANDLE_FLAG_FOR_IMPROVEMENT_CHANGE = 'handleFlagForImprovementChange',
  HANDLE_INTERNAL_NOTES_CHANGE = 'handleInternalNotesChange',
  HANDLE_TOP_INDEPENDENT_STATUS_CHANGE = 'handleTopIndependentStatusChange',
}

export enum Categories {
  BASIC_SCORE = 'basicScore',
  BONUS_SCORE = 'bonusScore',
  EXCLUDE_FROM_DISCOVER = 'excludeFromDiscover',
  EXCLUDE_FROM_MATCHING = 'excludeFromMatching',
  FLAG_FOR_IMPROVEMENT = 'flagForImprovement',
  INTERNAL_NOTES = 'internalNotes',
  PROJECTS_SCORE = 'projectsScore',
  SERVICES_SCORE = 'servicesScore',
  TOP_INDEPENDENT_STATUS = 'topIndependentStatus',
}

export type RatingMenuProps = {
  currentRating: RatingsState;
  onMutationSuccess?: () => void;
  userId: string;
};

export type RatingsAction =
  | HandleExcludeFromDiscoverChange
  | HandleExcludeFromMatchingChange
  | HandleFlagForImprovementChange
  | HandleInternalNotesChange
  | HandleTopIndependentStatusChange;

export type RatingsState = {
  hasChanges?: boolean;
  rating: {
    [key: string]: boolean | null | number | string;
    excludeFromDiscover: boolean | null;
    excludeFromMatching: boolean | null;
    flagForImprovement: boolean | null;
    internalNotes: null | string;
    topIndependentStatus: TopIndependentStatus;
  };
};

export type RatingSystem = RatingCategory[];

type HandleExcludeFromDiscoverChange = {
  payload: {
    category: Categories.EXCLUDE_FROM_DISCOVER;
    value: boolean;
  };
  type: ActionTypes.HANDLE_EXCLUDE_FROM_DISCOVER_CHANGE;
};

type HandleExcludeFromMatchingChange = {
  payload: {
    category: Categories.EXCLUDE_FROM_MATCHING;
    value: boolean;
  };
  type: ActionTypes.HANDLE_EXCLUDE_FROM_MATCHING_CHANGE;
};

type HandleFlagForImprovementChange = {
  payload: {
    category: Categories.FLAG_FOR_IMPROVEMENT;
    value: boolean;
  };
  type: ActionTypes.HANDLE_FLAG_FOR_IMPROVEMENT_CHANGE;
};

type HandleInternalNotesChange = {
  payload: {
    category: Categories.INTERNAL_NOTES;
    value: string;
  };
  type: ActionTypes.HANDLE_INTERNAL_NOTES_CHANGE;
};

type HandleTopIndependentStatusChange = {
  payload: {
    category: Categories.TOP_INDEPENDENT_STATUS;
    value: TopIndependentStatus;
  };
  type: ActionTypes.HANDLE_TOP_INDEPENDENT_STATUS_CHANGE;
};

type RatingCategory = {
  category: Categories;
  label: string;
  values?: number[];
};
